module.exports = __webpack_public_path__ + "static/media/D0.ebed3403.svg";